/** @format */

import React, { useRef, useState } from 'react';
import { FilterPod, TableComponents, SimpleDialog, ExportButton } from 'components';
import { toFilterVOS } from 'components/FilterPod';
import { enifyDateTime } from 'utility';
import { Grid, Box } from '@mui/material';
import createToast from 'components/Toast/Toast';
import { useExportFile } from 'hooks';
import { DelegationDetails, DetailPanel, TransferDelegation } from './components';
import AssignedDelegationServices from './services/ReceivedDelegationServices';
import { columns, generateData } from './components/Columns';
import { putDefaultList } from './services/ReceivedDelegationServices';
import { useStyles } from '../../style';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import { getExportReceivedDelegationUrl } from 'URLs';
import { useCurrencyUnit } from 'hooks';

// TODO: Detail button is not responsive
// TODO: Some Transfer Button should be disabled as condition
const AssignedDelegation = () => {
  // -- STATES --//
  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    page,
    setPage,
    size,
    setSize,
    activeDetailID,
    setActiveDetailID,
    filters,
    setFilters,
    isTransferOpen,
    setIsTransferOpen,
    targetTransferDelegation,
    setTargetTransferDelegation,
    dataDialog,
    setDataDialog,
    showDialog,
    setShowDialog,
  } = useCustomHook();

  // --HOOKS--//
  const classes = useStyles();
  const tableRef = useRef(null);
  let actionsList = getDynamicObjectAction([
    'selfAccountDelegationPage',
    'exportAccountDelegationBtn',
    'transferAccountDelegationBtn',
    'defaultAccountDelegationBtn',
    'detailAccountDelegationBtn',
  ]);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const { downloadFile, isExporting } = useExportFile({
    url: getExportReceivedDelegationUrl(),
    filename: 'received-delegations-report',
  });
  const currencyText = useCurrencyUnit(false);

  const getDelegations = async (query) => {
    try {
      setLoading(true);

      // Handle Order By
      let orderBy = [];
      let orderByName = null;

      switch (query?.orderBy?.title) {
        case 'تخصیص‌دهنده':
          orderByName = 'نام و نام خانوادگی کاربر تخصیص دهنده';
          break;
        case `به میزان - ${currencyText}`:
          orderByName = 'میزان';
          break;
        case `میزان مصرف - ${currencyText}`:
          orderByName = 'استفاده شده';
          break;
        case 'شروع':
          orderByName = 'زمان شروع';
          break;
        case 'انقضا':
          orderByName = 'زمان انقضا';
          break;
        case 'شارژ مجدد':
          orderBy = [
            {
              name: 'دوره',
              isDesc: query?.orderDirection === 'desc',
            },
            {
              name: 'تعداد شارژ مجدد',
              isDesc: query?.orderDirection === 'desc',
            },
          ];
          break;
        case 'وضعیت':
          orderByName = query?.orderBy?.title;
          break;

        default:
          break;
      }
      if (orderByName && orderBy.length === 0) {
        orderBy = [
          {
            name: orderByName,
            isDesc: query?.orderDirection === 'desc',
          },
        ];
      }

      const filter = toFilterVOS([...filters]);
      const params = {
        page: query ? query?.pageNumber : page,
        size: query?.pageSize || size,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await AssignedDelegationServices.getAssignedDelegation(data, params);

      let list = [];
      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const onTransfer = (targetDelegation) => {
    if (!targetDelegation) return;
    if (targetDelegation?.status?.includes('غیر')) {
      return createToast('خطا', 'امکان انتقال اعتبار غیر فعال وجود ندارد.', 'danger');
    }
    setTargetTransferDelegation(targetDelegation);
    setIsTransferOpen(true);
  };

  const putDefault = async (delegationId) => {
    if (!delegationId) return;
    try {
      const result = await putDefaultList(delegationId);
      setPage(0);
      setSize(10);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100);
    } catch (error) {}
  };

  const onResetTransfer = () => {
    setIsTransferOpen(false);
    setTargetTransferDelegation(null);
  };

  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="end" alignItems="flex-end" style={{ marginBottom: 16 }}>
          {actionsList['selfAccountDelegationPage'] && (
            <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
          )}
          {actionsList['exportAccountDelegationBtn'] && (
            <ExportButton loading={isExporting} types={['xls', 'csv']} onExport={onExport} />
          )}
        </Box>
        {actionsList['selfAccountDelegationPage'] && (
          <Box>
            <FilterPod
              filters={filters}
              onChange={onFiltersChange}
              openFilterDialog={openFilterDialog}
              setOpenFilterDialog={setOpenFilterDialog}
              handleCloseFilterDialog={handleCloseFilterDialog}
            />
          </Box>
        )}
      </Grid>
      {actionsList['selfAccountDelegationPage'] && (
        <TableComponents
          data={getDelegations}
          columns={columns(
            setActiveDetailID,
            onTransfer,
            putDefault,
            actionsList,
            classes,
            setShowDialog,
            setDataDialog,
          )}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber);
            setSize(ps?.pageSize);
            return getDelegations(ps);
          }}
        />
      )}
      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={showDialog}
        title={'جزئیات اعتبار تخصیص داده شده'}
        onClose={() => setShowDialog(false)}
      >
        <DetailPanel delegationId={dataDialog?.delegationId} />
      </SimpleDialog>
      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={activeDetailID !== null}
        title="گزارش مصرف اعتبار دریافتی"
        onClose={() => setActiveDetailID(null)}
      >
        <DelegationDetails delegationId={activeDetailID} />
      </SimpleDialog>
      <SimpleDialog
        open={isTransferOpen}
        title="انتقال وجه تفویض شده به کاربر دیگر"
        onClose={onResetTransfer}
      >
        <TransferDelegation
          targetDelegation={targetTransferDelegation}
          onCancel={onResetTransfer}
        />
      </SimpleDialog>
    </>
  );
};

// See detail for every row

export default AssignedDelegation;
